import axios from 'axios'
import ParamUtils from '@/core/utils/ParamUtils'

class ArquivoApi {

    async download(uriArquivo) {
        return await axios.get(`/compra-direta/api/public/v1/arquivos?uri=${uriArquivo}&thumbnail=false`, {
            responseType: 'arraybuffer'
        })
    }

    async baixarDocumentoVirtualizado(documentoVirtualizadoId, opcaoDownloadVirtualizacao, nomeArquivo, compraDiretaId, noProcessoDigital){
        const paramObj = {
            documentoVirtualizadoId:documentoVirtualizadoId,
            nomeArquivo:nomeArquivo,
            opcaoDownloadVirtualizacao:opcaoDownloadVirtualizacao
        }
        return await axios.get(
            `/compra-direta/api/public/v1/compras-direta/${compraDiretaId}/documentos-virtualizados/download?noProcessoDigital=${noProcessoDigital}&` +
            ParamUtils.ObjectsToParams([paramObj]),
            {
                responseType: 'arraybuffer'
            }
        )
    }

}

export default new ArquivoApi()